import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 32px 142px;

  @media (max-width: 768px) {
    margin: 24px 16px 32px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const HeaderTexts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
`;

export const PhoneNumber = styled.span`
  font-weight: 600;
  color: #1e2939;
`;

export const Title = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0;
  line-height: 28px;

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 26px;
  }
`;

export const SubTitle = styled.h6`
  font-size: 14px;
  font-weight: 400;
  color: #374151;
  margin-bottom: 0;
  line-height: 140%;
  margin-top: 4px;
  margin-bottom: 24px;
  overflow-wrap: anywhere;
`;

export const ResendText = styled.div`
  font-size: 14px;
  line-height: 140%;
  color: #6b7280;
  margin-top: 24px;
`;

export const OtpLoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
  color: #6b7280;
  font-size: 14px;
  line-height: 140%;

  .otp-inline-loader {
    width: auto;
    flex: 0 0 auto;
    box-shadow: none;
    background: transparent;
  }

  .otp-inline-loader svg {
    width: 24px;
    height: 24px;
  }
`;

export const ResendButton = styled.div`
  text-decoration: underline;
  color: #e6000f;
  font-size: 14px;
  line-height: 140%;
  font-weight: 500;
  margin-top: 24px;
  cursor: pointer;
`;
